/**
 * Gates the MiB plan-aware UI: locked nav badges, gated editors, and the
 * upsell takeover/modal surfaces. Front-end display gate only — backend
 * enforcement lives behind `olympus.jpcMiBCapabilities`.
 */
export const MIB_GATES_FLAG = 'hermes.jpcMiBGates'
